module.exports = __webpack_public_path__ + "static/media/push-pin.b6278bd9.svg";